<template>
  <div
    :style="focusableStyle"
    @click="$emit('update:value', !value)"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <div :style="boxStyle">
      <c-icon
        v-if="value"
        type="check-mark"
        color="white"
      />
    </div>
  </div>
</template>

<script>
import CIcon from 'shared/components/CIcon.vue';

export default {
  name: 'CCheckbox',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  components: { CIcon },
  emits: ['update:value'],
  data() {
    return { hover: false };
  },
  computed: {
    boxStyle() {
      const style = {
        width: '16px',
        height: '16px',
        cursor: 'pointer',
      };
      const middlewares = [this.makeBackground, this.makeBoxShadow];
      return middlewares.map((m) => m(style));
    },
    focusableStyle() {
      return {
        width: '16px',
        height: '16px',
        userSelect: 'none',
        transition: 'background 20ms ease-in 0s',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },
  },
  methods: {
    makeBoxShadow(style) {
      if (this.value) {
        return {
          ...style,
          boxShadow: `0 0 0 2px ${this.$colors.blue.base}`,
        };
      }
      return {
        ...style,
        boxShadow: `0 0 0 2px ${this.$colors.grey.darken2}`,
      };
    },
    makeBackground(style) {
      if (this.value) {
        return {
          ...style,
          background: this.$colors.blue.base,
        };
      }
      if (this.hover) {
        return {
          ...style,
          background: this.$colors.grey.lighten7,
        };
      }
      return {
        ...style,
        background: 'transparent',
      };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
</style>
